{
  "remove": "Ta bort"
}
